package uk.co.nickthecoder.kyd

/**
 * A [ParentResource] which has no data of its own, but only acts as a parent for a
 * group of [children].
 */
class Folder(

    parent: ParentResource,
    name: String

) : AbstractParentResource(parent, name) {

    override val resourceType: ResourceType
        get() = ResourceType.FOLDER

}
